import React from 'react';
import styled from '@emotion/styled';
import { Form } from 'react-final-form';
import LinkPrompt from './LinkPrompt';
import ImagePrompt from './ImagePrompt';
import IframePrompt from './IframePrompt';
import { ModalHeader, ModalBody, ModalActions, Form as ToolkitForm } from '@contently/toolkit';

const { Button, CancelLinkButton } = ToolkitForm;

export const PromptOverlay = styled('div')`
  height: 100%;
  width: 100%;
  background-color: #00000063;
  position: absolute;
  z-index: 1;
`;

const PromptPositionWrapper = styled('div')`
  position: absolute;
  top: 300px;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`;

const PromptWrapper = styled('div')`
  background-color: white;
  border: 1px solid lightgray;
  border-radius: 3px;
  min-height: 100px;
  width: 400px;
`;

const formMap = {
  link: LinkPrompt,
  image: ImagePrompt,
  iframe: IframePrompt
};

function Prompt({ pluginItem, onClose }) {
  const formData = pluginItem.existingAttrs || {};

  function buildModalHeader(pluginItem) {
    if (pluginItem.item.modalHeader) {
      return pluginItem.item.modalHeader;
    } else {
      return `Insert ${pluginItem.item.name}`;
    }
  }

  const promptItem = pluginItem.item;
  const FormComponent = formMap[promptItem.name];

  return (
    <PromptPositionWrapper>
      <PromptWrapper>
        <ModalHeader>{buildModalHeader(pluginItem)}</ModalHeader>
        {/* @ts-ignore */}
        <Form
          onSubmit={(formData) => {
            promptItem.onSave(pluginItem.plugin.editorView, formData);
          }}
          render={({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit}>
              <ModalBody>
                <FormComponent formData={formData} />
              </ModalBody>
              <ModalActions>
                <CancelLinkButton href="/" onClick={onClose} />
                <Button type="submit" variant="primary" disabled={submitting}>
                  Save
                </Button>
              </ModalActions>
            </form>
          )}
        />
      </PromptWrapper>
    </PromptPositionWrapper>
  );
}

export default Prompt;



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/prompts/Prompt.jsx